'use strict';

import axios from 'axios';
import CryptoJS from 'crypto-js';
import { addDays, differenceInDays } from 'date-fns';
import ct from 'countries-db';
import ctz from 'countries-and-timezones';
import cdate from 'date-and-time';
import moment from 'moment';
import { useCookies } from "vue3-cookies";
import { useI18n } from 'vue-i18n';
import config from '@/config/config.json';


const { cookies } = useCookies();

export function getCookie(id) {
	return cookies.get(id);

}

function getDecryptedKey(data, hashkey) {
	var bytes = CryptoJS.AES.decrypt(data, hashkey);
	return bytes.toString(CryptoJS.enc.Utf8);
}

export function checkLoggedIn() {
	if (getCookie("uid")) { 
		document.location.href = '/';
		return false;
	}
}

export function isMemberAuthorized(){
	return checkSubscription();
}

export function generateRandomAlphaNum(len) {
	var rdmstring = "";
	for (; rdmstring.length < len; rdmstring += Math.random().toString(36).substr(2));
	return rdmstring.substr(0, len);
}

export function checkSubscription() {
	if (!getCookie("us")) return false;
	let dkey = JSON.parse(getDecryptedKey(getCookie("us"), config.clientkey));
	let activedate = dkey.sdactivedate;
	let activeperiod = dkey.stperiod;
	let activedateperiod = addDays(activedate, activeperiod);
	let dif = differenceInDays(activedateperiod, new Date());
	if (dif < 0) {
		return false;
	}
	return true;
}

export function cleanUser() {
	localStorage.removeItem("token");
	localStorage.removeItem("trialing");
	localStorage.removeItem("company");
	localStorage.removeItem("iscompany");
	localStorage.removeItem("isstudent");
	localStorage.removeItem("isteacher");
	localStorage.removeItem("school");
}

export function getSubscription() {
	if (!getCookie("us")) return false;
	let dkey = JSON.parse(getDecryptedKey(getCookie("us"), config.clientkey));
	return dkey;
}

export async function sendMail(options, csrftoken) {
	// let csrftoken = await getCRF();
	let token = localStorage.getItem("token");
	return new Promise(async (resolve) => {
		await axios
			.post('/api/v1/sendmail', options, {
				headers: {
					Authorization: `${token}`,
					'X-CSRF-TOKEN': csrftoken
				},
				withCredentials: true,
				withXSRFToken: true
			})
			.then(response => {
				if (response.data.Error) {
					resolve(false);
					return;
				}
				resolve(true);

			}).catch(error => {
				console.log("error", error);
				resolve(false);
			})
	})
}

export function capitalize(text) {
	if (!text) return;
	return text.charAt(0).toUpperCase() + text.slice(1);
}

export function countryDateTime(lng, tz) {
	if (lng == 'el') {
		lng = "EL";
	}
	let lc = new Date().toLocaleTimeString(lng, { timeZone: tz, hour12: true });
	lc = lc.replace('π.μ.', "am");
	lc = lc.replace('μ.μ.', "pm");
	return lc;
	
}

export function fromGreekDateTimeTo(country, idate) {
	if (!idate) { return "" }
	const countrybase = ct.getCountry('GR');
	const timezonebase = ctz.getTimezone(countrybase.timezones[0]);
	const countrysel = ct.getCountry(country);
	const timezone = ctz.getTimezone(countrysel.timezones[0]);
	let date = new Date(idate)
	let utc = cdate.format(date, 'YYYY/MM/DD hh:mm A [GMT]Z', true);	
	let utcd = new Date(utc);
	let rdate = cdate.addHours(utcd, parseInt(timezone.utcOffsetStr) - parseInt(timezonebase.utcOffsetStr));
	return cdate.format(rdate, 'YYYY/MM/DD HH:mm');
	
}

export function getCRF() {
	return new Promise(async (resolve) => {
		await axios
			.get('/api/v1/getcrf', {
				withCredentials: true
			})
			.then(response => {
				resolve(response.data.crf);
			});
	})
}

export function toLocalDate(date) {
	let loc = getCookie("ucountry");
	if (!loc) return;
	const country = ct.getCountry(loc);
	if (loc == 'GR') {
		country.languages[0] = "gr";
	}
	return date ? date.toLocaleDateString(country.languages[0], { timeZone: country.timezones[0] }) : '';
}

export function toLocalDateTime(date) {
	let loc = getCookie("ucountry");
	if (!loc) return;
	const country = ct.getCountry(loc);
	if (loc == 'GR') {
		country.languages[0] = "gr";
	}
	return date ? date.toLocaleString(country.languages[0], { timeZone: country.timezones[0] }) : '';
	
}


export function getPastDateToAgoString(dp) {
	const { t } = useI18n({ useScope: "global" });
	if (!dp) return;
	let pdl = toLocalDateTime(new Date(dp));
	let dposted = moment(pdl, 'DD-MM-YYYY  HH:mm');
	let today = moment();
	let m3 = today.diff(dposted,'minutes');
	let m4 = today.diff(dposted,'h');
	let m5 = today.diff(dposted,'months');
	let numdays = Math.floor(m3 / 1440);
	let numhours = Math.floor((m4 % 1440) / 60);
	let numminutes = Math.floor((m3 % 1440) % 60);
	let nummonths = Math.floor((m5) );
	let ret = "";
	if (!nummonths) {	
		ret += (numdays) ?  numdays + " " + t("common.days", "day(s)") + " " : "";
		ret += (numhours) ?  numdays + " " +  t("common.hours", "hour(s)") + " " : "";
		ret += (numminutes) ?  numminutes + " " +  t("common.minutes", "minutes(s)") + " " : "";
	} else {
		ret = nummonths + " " +  t("common.monthsubs", "month(s)");
	}
	if (numminutes < 1) {
		ret = "Less than minute"
	}
	return ret;
}

export function getDateToLocalString(dp) {
	return toLocalDateTime(new Date(dp));
}

export function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

export function validateEmail(email) {
	return String(email).toLowerCase()
		.match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		) ? true: false ;
}

export function siteSeal(id) {
	let tmpseal = `<div id="DigiCertClickID_C5ph9aP7Seal" class="img-fluid" style="text-decoration: none; text-align: center; display: block; vertical-align: baseline; font-size: 100%; font-style: normal; text-indent: 0px; line-height: 1; width: auto; margin: 0px auto; padding: 0px; border: 0px; background: transparent; position: relative; inset: 0px; clear: both; float: none; cursor: default;"><img src="/assets/img/payments/digicert-siteseal.svg?tag=C5ph9aP7&amp;referer=www.digicert.com&amp;format=png&amp;lang=en&amp;seal_number=18&amp;seal_size=s&amp;an=min&amp;cbr=1735890868848" alt="DigiCert Secured Site Seal" tabindex="0" role="link" style="text-decoration: none; text-align: center; display: block; vertical-align: baseline; font-size: 100%; font-style: normal; text-indent: 0px; line-height: 1; width: 100%; margin: 0px auto; padding: 0px; border: 0px; background: transparent; position: relative; inset: 0px; clear: both; float: none;"></div>`;
	document.getElementById(id).innerHTML = tmpseal;
	// var __dcid = __dcid || [];
	// __dcid.push({ "cid": "DigiCertClickID_C5ph9aP7", "tag": "C5ph9aP7" });
	// (function() { var cid = document.createElement("script");
	// 	cid.async = true;
	// 	cid.src = "//seal.digicert.com/seals/cascade/seal.min.js"; var s = document.getElementsByTagName("script"); var ls = s[(s.length - 1)];
	// 	ls.parentNode.insertBefore(cid, ls.nextSibling); }());
}

export function getInnerHeight(elm){
	let computed = getComputedStyle(elm),
	padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);

	return elm.clientHeight - padding
}

export function initAnimation() {
	document.addEventListener('scroll', function() {
		if (document.querySelectorAll(".chkpos").length === 0) {
			checkPos();
		} else {
			setTimeout(function() {
				var timeoutId = null;
				if (timeoutId) clearTimeout(timeoutId);
				timeoutId = setTimeout(checkPos, 30);
			});
		}
	});
}

export function initCustonAnimation(fnc, delay) {
	if (delay) {
		document.addEventListener('scroll', initTimeout);
		
	} else {
		initCustonAnimationPlay();
	}
	function initTimeout() {
		setTimeout(function() {
			var timeoutIdc = null;
			if (timeoutIdc) clearTimeout(timeoutIdc);
			timeoutIdc = setTimeout(checkTempPos(cfnc), 30);
		});
	}
	function cfnc() {
		setTimeout(() => {
			initCustonAnimationPlay();
			document.removeEventListener('scroll', initTimeout);
		}, delay)
	}
	function initCustonAnimationPlay() {
		document.addEventListener('scroll', function() {
			if (document.querySelectorAll(".customanimation").length === 0) {
				return;
			} else {
				setTimeout(function() {
					var timeoutId = null;
					if (timeoutId) clearTimeout(timeoutId);
					timeoutId = setTimeout(checkCustomPos(fnc), 30);
				});
			}
		});
	}
}


function checkTempPos(fnc) {
	var elementsToShow = document.querySelectorAll('.customanimation');
	for (var i = 0; i < elementsToShow.length; i++) {
		let val = (elementsToShow[i]);
		if (isElementInViewport(val)) {
			fnc();
			return;
		}
	}
}

function checkCustomPos(fnc) {
	var elementsToShow = document.querySelectorAll('.customanimation');
	for (var i = 0; i < elementsToShow.length; i++) {
		let val = (elementsToShow[i]);
		if (isElementInViewport(val)) {
			val.classList.remove('customanimation');
			fnc();
		}
	}
}

function checkPos() {
	var elementsToShow = document.querySelectorAll('.entry.animated');
	for (var i = 0; i < elementsToShow.length; i++) {
		let val = (elementsToShow[i]);
		let has = Array.from(val.classList).find(c => c.startsWith('slide-'));
		if (!has?.length) break; 
		if (isElementInViewport(val)) {
			let nhas = has.replace('-', '');
			val.style.opacity = 0;
			val.classList.remove('entry');
			setTimeout(() => {
				val.style.opacity = 1;
				val.classList.add(nhas);
			}, 100);
		}
	}
}

function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
	var recttop = rect.top;
	var rectbottom = rect.bottom;
	var wih  =  (window.innerHeight|| document.documentElement.clientHeight) ;
	return (
		(recttop <= 0 &&
			rectbottom >= 0) ||
		(rectbottom >= (wih) &&
			recttop <= (wih)) ||
		(recttop >= 0 &&
			rectbottom <= (wih))
	);
}